import { useEffect, useRef } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';

import { eventsSnackBarAtom, syncErrorRootEmailAtom } from '../data-access';
import { translateI18n } from '../i18n';
import { useHandleCalSyncError } from './useHandleCalSyncError';

export const useCalendarSyncErrorSnackbar = () => {
  const syncErrorRootEmail = useRecoilValue(syncErrorRootEmailAtom);
  const [, setEventsSnackbar] = useRecoilState(eventsSnackBarAtom);
  const { handleConnect, syncErrorInfo } = useHandleCalSyncError({ syncErrorRootEmail });
  const lastShownEmailRef = useRef<string | undefined>();

  useEffect(() => {
    if (!syncErrorRootEmail) {
      lastShownEmailRef.current = undefined;
      return;
    }

    if (!syncErrorInfo?.calendarType) {
      return;
    }

    if (lastShownEmailRef.current === syncErrorRootEmail) {
      return;
    }

    lastShownEmailRef.current = syncErrorRootEmail;

    const message = translateI18n('calendar.sidebar.authorizeEmailAgain', {
      email: syncErrorRootEmail,
    }).replace('\n', ' ');

    setEventsSnackbar({
      message,
      actionLabel: translateI18n('calendar.sidebar.reconnect'),
      autoHideDuration: 5000,
      type: 'error',
      onPress: () => {
        handleConnect(syncErrorInfo.calendarType!);
      },
    });
  }, [syncErrorRootEmail, syncErrorInfo, handleConnect, setEventsSnackbar]);
};
